import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { environment } from '@et/environment';
import { configureAgGrid } from '@et/shared';
import { getDocPrepServiceDomain } from '@et/utils';
import { AppModule } from './app/app.module';
import * as Sentry from '@sentry/angular';

configureAgGrid();

Sentry.init({
  dsn: environment.sentryDns,
  environment: environment.environment,
  enabled: environment.production,
  integrations: [Sentry.browserTracingIntegration()],
  tracePropagationTargets: [
    'localhost',
    getDocPrepServiceDomain(),
    environment.apiServer.domain,
    environment.docio.domain,
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: environment.environment === 'prod' ? 1.0 : 0,
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    applicationProviders: [provideZoneChangeDetection()],
  })
  .catch((err) => console.error(err));
